import {Component} from '@angular/core';

@Component({
  selector: 'lt-item-unavailable-view',
  templateUrl: './item-unavailable-view.component.html',
  styleUrls: ['./item-unavailable-view.component.scss'],
})
export class ItemUnavailableViewComponent {}
